export default __webpack_public_path__ + "static/media/MUSKAAN KOCHAR.99f63b9c.jpg";